import { useCrossDockOptions } from 'components/procurement/components/purchaseOrdersV2/queries/PurchaseOrderQueries';

/**
 * Resolves inbound cross dock service fee for the selected destination cross dock.
 * Reuses the same React Query cache as CrossDockPicker / useCrossDockOptions.
 *
 * @param {string|number} crossDockId
 * @param {{ enabled?: boolean }} [options]
 */
export function useInboundCrossDockServiceFee(crossDockId, options = {}) {
    const normalizedId = Number(crossDockId);
    const hasId = Number.isFinite(normalizedId) && normalizedId > 0;
    const enabled = options.enabled !== false;

    const query = useCrossDockOptions({ enabled });

    const match = hasId ? (query.data ?? []).find((row) => Number(row.value) === normalizedId) : undefined;
    const serviceFee = Number(match?.serviceFee);
    const data = Number.isFinite(serviceFee) && serviceFee >= 0 ? serviceFee : 0;

    return {
        ...query,
        data: hasId ? data : 0,
    };
}
